import React from 'react';
import { Button } from 'reactstrap';
import { addApplicationUrl } from '../../../../../utils/applicant_tracking/application';

interface PropTypes {
  candidateId: number;
  referralFlow?: boolean;
  applicationsCount: number;
  recentApplicationId: number | null;
  applicationJobTitles: string[];
  onClose: () => void;
}

export function ExistingCandidateBody(props: PropTypes) {
  return (
    <>
      <div className='fs-4 mb-6h'>
        This candidate already exists and has {props.applicationsCount}{' '}
        application(s).
        {props.applicationJobTitles?.length > 0 && (
          <ul className='mt-2'>
            {props.applicationJobTitles.map((title, index) => (
              <li key={index}>{title}</li>
            ))}
          </ul>
        )}
      </div>
      <div className='d-flex justify-content-end'>
        <Button className='me-2' color='danger' onClick={props.onClose}>
          Cancel
        </Button>
        {props.recentApplicationId && (
          <Button
            className='me-2'
            color='secondary'
            onClick={() =>
              (window.location.href = `/applications/${props.recentApplicationId}`)
            }
          >
            View Existing Applications
          </Button>
        )}
        <Button
          color='primary'
          onClick={() =>
            (window.location.href = addApplicationUrl(
              props.candidateId,
              props.referralFlow,
            ))
          }
        >
          Add New Application
        </Button>
      </div>
    </>
  );
}
